// @flow
import idnAllowedCodePoints from 'idn-allowed-code-points-regex';
/*
This is a regular expression that matches any of the code points that Verisign allows by default in IDN.

Example: This regex will allow users to upload Pins with websites such as:
http://ШНУР-КУПИТЬ.рф

Github to Mathias Bynens
https://github.com/mathiasbynens/idn-allowed-code-points-regex

Quick link to the regex:
https://raw.githubusercontent.com/mathiasbynens/idn-allowed-code-points-regex/master/index.js
*/

const httpsRegex = /^(https?:\/\/){0,1}/;
const dotRegex = /(\.){1,}/;
const forwardSlashRegex = /(\/){0,1}/;

export default new RegExp(
  httpsRegex.source +
    '(' +
    idnAllowedCodePoints.source +
    '){1,}' +
    dotRegex.source +
    '(' +
    idnAllowedCodePoints.source +
    '){1,}' +
    forwardSlashRegex.source,
  'gi',
);
